@import "config";

.emptyState {
	padding: $spacing-inline-xxs;

	h3 {
		color: $color-dark-d1;
		font-size: $font-size-xs;
		font-weight: $font-weight-bold;
		text-align: center;

		margin-bottom: $spacing-inline-nano;
	}

	p {
		color: $color-dark-d4;
		font-size: $font-size-xxs;
		text-align: center;
		margin: 0;
	}
}

.table {
	margin: 0;
	width: 100%;

	thead th,
	tbody td,
	tfoot td {
		padding: $spacing-inline-xxxs;
	}

	thead th:first-child {
		border-top-left-radius: $border-radius-sm;
	}

	thead th:last-child {
		border-top-right-radius: $border-radius-sm;
	}

	tfoot td:first-child {
		border-bottom-left-radius: $border-radius-sm;
	}

	tfoot td:last-child {
		border-bottom-right-radius: $border-radius-sm;
	}

	thead tr th,
	tfoot tr td {
		color: $color-dark-d1;
		font-size: $font-size-xs;
		font-weight: $font-weight-bold;
		background-color: $color-light-l3;
	}

	tbody tr td {
		color: $color-dark-d1;
		font-size: $font-size-xxs;
		font-weight: $font-weight-bold;
	}

	tbody tr {
		border-bottom: 1px solid $color-light-l2;
	}

	tbody tr:hover {
		background-color: $color-light-l2;
	}
}

.footer {
	@include flex(row, flex-end, flex-end);
}

.footerSpacing {
	td {
		padding: $spacing-inline-xxs !important;
	}
}

.title {
	color: $color-dark-d1;
	font-size: $font-size-xxs;
	font-weight: $font-weight-bold;
}

.description {
	color: $color-dark-d3;
	font-size: $font-size-xxxs;
	font-weight: $font-weight-regular;
	text-transform: uppercase;
}

.totalizer {
	background-color: $color-highlight-lightest;
}

.tooltipContent {
	position: relative;
}